import { getRuntimeConfig } from '@front/runtime-config'

const {
  public: { monorepoServiceFeatureTogglesUrl: monorepoUrl },
} = getRuntimeConfig()

export const getFlagsUrl = `${monorepoUrl}/flags`
